import {SET_PENDING_TRANSACTIONS,NEW_EVENT,SET_LOADING} from '../../types';
import { sendTx, BASE_BLOCK_SIZE  } from '../../helpers/bc';
import { fromUnit} from '../../../config';
import { getNRGBalance, getSpendableOutpoints } from '../../passport/get';
import { getWallet } from '../../helpers/wallet';
import {createTakerOrderTransaction} from 'bc-sdk/dist/transaction'
import {Decimal} from 'decimal.js';

export function cancelOrder({ password,order},done){
  return async function(dispatch,getState) {
    try {
      dispatch({type:SET_LOADING,payload:true})
      const state = getState()
      let address = order.address;
      let { privateKey: bcPrivateKeyHex} = getWallet(getState,address,'nrg', password)
      let collateral = order.collateralizedNrg;

      let spendableOutpointsList = state.passport.spendableOutpoints[address]
      if(!spendableOutpointsList || spendableOutpointsList.length === 0){
        await getSpendableOutpoints(dispatch, state)
        spendableOutpointsList = state.passport.spendableOutpoints[address]
      }
      if(!spendableOutpointsList || spendableOutpointsList.length === 0){
        dispatch({type:SET_LOADING,payload:false})
        done('Transaction exceeds balance.')
        return
      }

      const makerOrderInfo = {
        doubleHashedBcAddress: order.doubleHashedBcAddress,
        nrgUnit: order.nrgUnit.toString(),
        collateralizedNrg: order.collateralizedNrg.toString(),
        txHash: order.txHash,
        txOutputIndex: order.txOutputIndex,
        base: order.base,
        fixedUnitFee: order.fixedUnitFee
      }

      const tx = createTakerOrderTransaction(
        spendableOutpointsList,
        order.receivesToAddress.toString(), order.sendsFromAddress.toString(),
        makerOrderInfo,
        address.toString(), bcPrivateKeyHex.toString(),
        collateral.toString(), '1', true
      )

      const txSize = tx.serializeBinary().length

      let maxSize = Math.floor(BASE_BLOCK_SIZE * 2 / 3)
      if (maxSize <= txSize) {
        dispatch({type:SET_LOADING,payload:false})
        done('Please Consolidate Your UTXOs')
        return
      }

      let data = await sendTx(state.settings.settings, tx)

      if(data.txHash){
        await getSpendableOutpoints(dispatch,state)

        dispatch({
          type:SET_PENDING_TRANSACTIONS,
          payload: {hash:data.txHash,type:"Cancel Order",amount:collateral,chain:"NRG",from:address,to:'Tx Pending Pool'}
        });

        dispatch({type:SET_LOADING,payload:false})
        done(null,data);
      }
      else {
        dispatch({type:SET_LOADING,payload:false})
        done('Could not place order')
      }
      return
    }
    catch(err){
      console.log({err})
      dispatch({type:SET_LOADING,payload:false})
      if(err.toString().includes('val.to')) done('Transaction exceeds balance.')
      else if(err.toString().includes('Not enough balance')) done('Not enough NRG to Place Order')
      else done(err)
    }
  }
}
